import Fondo from "../assets/contact.png";
import Señora from "../assets/senora.png";
import { motion } from "framer-motion";

const Contact = () => {
	return (
		<div
			className="w-full h-fit md:min-h-screen bg-cover bg-center flex flex-col-reverse md:flex-row items-center justify-start p-4 md:p-12"
			style={{ backgroundImage: `url(${Fondo})` }}
		>
			<div className="w-full h-full flex flex-col justify-center gap-6">
				<h2 className="text-5xl text-yellow-400 font-bold text-center">
					{" "}
					Contáctenos
				</h2>
				<form className="w-full flex flex-col gap-4 text-yellow-200">
					<input
						type="text"
						placeholder="Tu nombre"
						className="border placeholder:text-white border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-white/5 "
					/>
					<input
						type="text"
						placeholder="Email"
						className="border placeholder:text-white border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-white/5 "
					/>
					<input
						type="text"
						placeholder="Telefono"
						className="border placeholder:text-white border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-white/5 "
					/>
					<textarea
						placeholder="Mensaje"
						rows="3"
						className="border placeholder:text-white border-gray-300 p-3 rounded-md resize-none outline-none focus:ring-2 focus:ring-yellow-300 bg-white/5 "
					></textarea>
					<button
						type="submit"
						className="bg-yellow-400 text-white py-4 px-4 rounded-full hover:bg-black transition"
					>
						Enviar opinión
					</button>
				</form>
			</div>
			<motion.div
				initial={{ opacity: 0, x: 100 }}
				whileInView={{ opacity: 1, x: 0 }}
				transition={{ duration: 1.5, ease: "easeOut" }}
				viewport={{ once: true, amount: 0.3 }}
				className="w-full h-full flex items-center justify-center"
			>
				<img
					src={Señora}
					alt="Señora"
					className="max-h-[80vh] object-contain"
				/>
			</motion.div>
		</div>
	);
};

export default Contact;
